import {
  Box,
  Container,
  Heading,
  // VStack,
  // Image,
  // Text,
  // Stack,
  HStack,
  CircularProgress,
  useDisclosure,
  // useToast,
  // Tab,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
} from "@chakra-ui/react";

// import { useHistory } from "react-router-dom";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
// import Button from "components/Button/Button";
// import Card, { getCardScheme } from "components/Card/Card";
import { CustomTab } from "./MyCard";

import VerifyAccountNotice from "components/Modals/cards/VerifyAccountNotice";

// import EmptyCards from "../../../assets/png/empty-cards.png";

// import { ReactComponent as AddCircleIcon } from "../../../assets/svg/add-circle.svg";

import {
  // useGetUserCardProfileQuery,
  useGetUserCardsQuery,
} from "services/cardsApi";

import { useMemo, useEffect, useState } from "react";

// import toLower from "lodash/toLower";
import VirtualCards from "./Panels/VirtualCards";
import PhysicalCards from "./Panels/PhysicalCards";
import VirtualCardLimitSupport from "components/Modals/cards/VirtualCardLimitSupport";
import { toLower } from "lodash";
import { toQueryString } from "util/utils";

import ls from "util/secureStorage";
import constant from "config/constant";

const Cards = (props) => {
  const currentPage = "Card";

  console.log("props", props);

  // const [shouldPoll, setShouldPoll] = useState(false);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isSupportOpen,
    onOpen: onSupportOpen,
    onClose: onSupportClose,
  } = useDisclosure();

  const [queries, setQueries] = useState({ active: true });

  const { data, isLoading, isFetching } = useGetUserCardsQuery(
    toQueryString(queries),
    {
      // pollingInterval: shouldPoll ? 800 : 0,
    }
  );

  const cards = useMemo(() => data?.data?.card, [data]);

  // const hasAnInactiveCard = useMemo(
  //   () => cards?.some((card) => card?.status !== "active"),
  //   [cards]
  // );

  // console.log({ shouldPoll, hasAnInactiveCard });

  // console.log("USER CARDS", cards);
  // console.log("USER DATA", props.userData);

  const isEligible = useMemo(
    () => props?.userData?.kycLevel === "three",
    [props?.userData]
  );

  useEffect(() => {
    if (!isEligible) {
      onOpen();
    }
  }, [props?.userData, isEligible, onOpen]);

  useEffect(() => {
    ls.remove(constant.TEMP_PIN);
    if (props?.userData && toLower(props?.userData?.country) !== "nigeria") {
      onSupportOpen();
    }
  }, [props.userData, onSupportOpen]);

  // useEffect(() => {
  //   if (hasAnInactiveCard && !shouldPoll) setShouldPoll(true);
  //   if (!hasAnInactiveCard && shouldPoll) setShouldPoll(false);
  // }, [hasAnInactiveCard, shouldPoll]);

  // const

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="cards">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="calc(100% - 15vw)" m="0">
            <HStack>
              <Heading>Cards</Heading>
              {isFetching && (
                <CircularProgress
                  ml="20px !important"
                  isIndeterminate
                  color="var(--primary)"
                  size="20px"
                />
              )}
            </HStack>

            <Box
              bg="white"
              border="1px solid #8688942f"
              // minH="681px"
              //   w="calc(100% - 25vw)"
              w="100%"
              mt="32px"
              borderRadius="8px"
              p={["10px", "10px", "28px"]}
            >
              <Tabs isFitted>
                <TabList border="none" borderRadius="6px" p="6px" bg="#D9DBE9">
                  <CustomTab>Virtual</CustomTab>
                  <CustomTab>Physical</CustomTab>
                </TabList>

                <TabPanels>
                  <TabPanel px="0">
                    <VirtualCards
                      cards={cards}
                      isEligible={isEligible}
                      isLoading={isLoading}
                      isFetching={isFetching}
                      userData={props?.userData}
                      setQueries={setQueries}
                    />
                  </TabPanel>
                  <TabPanel px="0">
                    <PhysicalCards
                      cards={[]}
                      isEligible={isEligible}
                      isLoading={isLoading}
                      isFetching={isFetching}
                    />
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Box>
          </Container>

          <VerifyAccountNotice isOpen={isOpen} onClose={onClose} />
          <VirtualCardLimitSupport
            isOpen={isSupportOpen}
            onClose={onSupportClose}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Cards;
